module.exports = __webpack_public_path__ + "static/img/serviceContent.7b3cc358.png";